import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthentication } from 'hooks/useAuthentication';

export const PrivateOutlet: React.FC = () => {
  const { isLoggedIn } = useAuthentication();
  return isLoggedIn() ? <Outlet /> : <Navigate to="/" />;
};
